<template>
	<div class="shops">
		<div class="null" v-if="list.length == 0">
			<img src="../../assets/image/nullbg.png">
			<p>抱歉，没有找到该渠道</p>
		</div>

		<div class="shoplist" v-if="list.length > 0">
			<div class="list">
				<div class="item" v-for="(v,k) in list" :key="k">
					<div class="name">
						<div class="h4">{{v.name}}</div>
						<div>配货率:<span :class="v.allocation_rate >= 86?'green':'red'">{{v.allocation_rate}}%</span>
						</div>
						<div>发货率:<span :class="v.on_time_rate >= 86?'green':'red'">{{v.on_time_rate}}%</span></div>
						<div>免费退货比例:<span
								:class="v.free_return_rate == 100?'green':'red'">{{v.free_return_rate}}%</span></div>
						<div>超出扣费:<span>{{v.exceed_rate_deduct}}%</span></div>
						<div class="gd"><span @click="onshoplist(v.id,v.code)">更多商品>></span></div>
					</div>
					<div class="product">
						<div class="p_item" v-for="(x,y) in v.product" :key="y" @click="ondetail(x.id)">
							<img class="img" :src="onimgarr(x.pic)[0]" v-if="onimgarr(x.pic)[0]">
							<img class="img" v-else src="../../assets/image/null.png">
							<p class="p1">{{x.brand}} {{x.sex}} {{x.cid_second}} {{x.cid_third}} {{x.style_number}}</p>
							<p class="p2">会员价<span>￥{{x.discount_price}}</span>起</p>
							<div class="zkbq">
								<div class="n">{{x.discount_str}}</div>
								<div>折起</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'shops',
		data() {
			return {
				keyword: "",
				page: 1,
				pageSize: 20,
				total: 0,
				list: []
			}
		},

		inject: ['onimgarr'],

		mounted() {
			// this.onlist();
		},

		watch: {
			'$route.query': {
				handler(newQuery, oldQuery) {
					this.keyword = newQuery.search;
					this.onlist();
				},
				deep: true, // 确保对象内部属性的变化也能被检测到
				immediate: true // 组件创建时立即执行一次handler
			}
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			onlist() {
				var obj = {
					keyword: this.keyword
				};
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('api/product/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			ondetail(val) {
				const url = this.$router.resolve({
					path: '/detail',
					query: {
						id: val
					}
				});
				window.open(url.href, "_blank");
			},
			
			onshoplist(id,code){
				this.$router.push({
					path: '/buyer/shoplist',
					query: {
						id: id
					}
				})
			}
		},
	}
</script>

<style scoped lang="less">
	.shops {
		width: 100%;
		height: 100%;
	}

	.null {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		img {
			width: 290px;
		}

		.p {
			margin-top: 20px;
			font-size: 16px;
			color: #999;
		}

		span {
			margin-top: 20px;
			color: #f98a46;
			font-size: 14px;
			cursor: pointer;
		}
	}

	.shoplist {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.list {
		width: 100%;
		height: calc(100% - 52px);
		overflow-y: auto;
		padding: 10px;
		box-sizing: border-box;

		.item {
			width: 100%;
			// height: 150px;
			background: #f5f9ff;
			border-radius: 10px;
			margin-bottom: 15px;
			padding: 15px;
			box-sizing: border-box;
			display: flex;
			align-items: center;

			.name {
				width: 200px;
				padding: 0 10px;
				box-sizing: border-box;

				.h4 {
					font-size: 20px;
					font-weight: bold;
				}

				div {
					font-size: 14px;
				}

				.gd {
					display: flex;
					color: #47a0ff;
					cursor: pointer;
				}
			}

			.product {
				width: calc(100% - 200px);
				display: flex;
				align-items: center;

				.p_item {
					width: calc(20% - 12px);
					padding: 4px;
					box-sizing: border-box;
					border-radius: 12px;
					border: 1px solid transparent;
					margin-left: 12px;
					cursor: pointer;
					position: relative;
					.img {
						width: 100%;
						border-radius: 10px;
					}

					p {
						color: #333;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;

					}

					.p1 {
						font-weight: bold;
					}

					.p2 {
						span {
							color: #F65730;
							font-size: 16px;
						}
					}

					.zkbq {
						width: 38px;
						height: 58px;
						background-image: url(../../assets/image/zkbq.png);
						background-size: 100%;
						background-repeat: no-repeat;
						position: absolute;
						top: 0;
						left: 10px;
						z-index: 9;
						color: #fff;
						text-align: center;
						padding-top: 2px;
						display: flex;
						flex-direction: column;
						.n {
							font-size: 14px;
						}
					}
				}

				.p_item:hover {
					border: 1px solid #F65730;
				}
			}
		}
	}

	.green {
		color: green;
	}

	.red {
		color: red;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/shops.vue